import { render } from "./IndividualInfoPostgraduate.vue?vue&type=template&id=7169781b&scoped=true"
import script from "./IndividualInfoPostgraduate.vue?vue&type=script&lang=js"
export * from "./IndividualInfoPostgraduate.vue?vue&type=script&lang=js"

import "./IndividualInfoPostgraduate.vue?vue&type=style&index=0&id=7169781b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7169781b"]])

export default __exports__